import { render, staticRenderFns } from "./AggiungiDati.vue?vue&type=template&id=481c3a58&"
import script from "./AggiungiDati.vue?vue&type=script&lang=js&"
export * from "./AggiungiDati.vue?vue&type=script&lang=js&"
import style0 from "./AggiungiDati.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports